import { Typography } from '@/components'
import { Column } from '@/components/styled'
import { ThemeColor } from '@/enums'
import { Button } from '@surein/ui'
import { SectionWrapper } from '../styles'
import { useTranslation } from 'react-i18next'
import { paths } from '@/routes/paths'
import { useGoToPath } from '@/utils'

export const AddContractSection = () => {
  const { t } = useTranslation()
  const goToAddInsuranceContract = useGoToPath(paths.addInsuranceContract)

  return (
    <SectionWrapper alignItems="start" gap="16px">
      <Column gap="4px">
        <Typography bold variant="h4">
          {t('locationPage.addContractTitle')}
        </Typography>
        <Typography variant="p2Body" color={ThemeColor.b50}>
          {t('locationPage.addContractDescription')}
        </Typography>
      </Column>
      <Button
        variant="secondary"
        shape="square"
        onClick={() => goToAddInsuranceContract()}
      >
        {t('locationPage.addContractButton')}
      </Button>
    </SectionWrapper>
  )
}
